import useSWR from 'swr';

const fetcher = url => fetch(url).then(r => r.json());

export default function useServiceItems() {
  const { data, error, isLoading } = useSWR(
    '/navigation/menu/service/',
    fetcher
  );

  return {
    serviceItems: data,
    isLoading,
    isError: error
  };
}
